import {
	HealthTestQuestionnaireFields,
	HealthTestQuestions
} from "../../types/components/healthTestQuestionaires.types";

export const healthTestQuestionaires: Array<HealthTestQuestions> = [
	{
		question: "What is the *Date of Birth*",
		question_type: "DATE",
		options: null,
		fieldname: "date_of_birth",
		value: "",
		placeholder: "Select the Date of Birth"
	},
	{
		question: "What's your *weight*?",
		question_type: "TEXT_INPUT",
		options: null,
		fieldname: "weight",
		value: "",
		placeholder: "Enter the weight in KGs"
	},
	{
		question: "What's your *Height*?",
		question_type: "TEXT_INPUT",
		options: null,
		fieldname: "height",
		value: "",
		placeholder: "Enter Height in Feets (Eg, 8.45)"
	},
	{
		question: "How much *water* do you typically drink per day?(in litre)",
		question_type: "MULTIPLE_CHOICE_QUESTION",
		options: ["1-2", "3-4", "MORE THAN 4"],
		fieldname: "daily_water_drinking",
		value: "",
		placeholder: ""
	},
	{
		question: "On Average, how many hours do you *sleep* at night?",
		question_type: "MULTIPLE_CHOICE_QUESTION",
		options: ["1-3 HOURS", "3-5 HOURS", "5-7 HOURS", "MORE THAN 7 HOURS"],
		fieldname: "sleep_time",
		value: "",
		placeholder: "Enter the sleep times in hours"
	},
	{
		question: "Do you engage in *regular exercise* or any *physical activity*?",
		question_type: "BOOLEAN",
		options: ["YES", "NO"],
		fieldname: "regular_exercise",
		value: "",
		placeholder: ""
	},
	{
		question: "Do you regularly schedule *health check-ups* or *visits to the doctor*?",
		question_type: "BOOLEAN",
		options: ["YES", "NO"],
		fieldname: "regular_health_checkup",
		value: "",
		placeholder: ""
	},
	{
		question: "Do you *meditate/practice* anything to calm your mind?",
		question_type: "BOOLEAN",
		options: ["YES", "NO"],
		fieldname: "meditation_practice",
		value: "",
		placeholder: ""
	},
	{
		question: "Do you maintain *strong social connections* and spend quality time with friends and family?",
		question_type: "BOOLEAN",
		options: ["YES", "NO"],
		fieldname: "social_connections",
		value: "",
		placeholder: ""
	},
	{
		question: "Do you have *zero exposure* to *environmental toxins* or *pollutants*?",
		question_type: "BOOLEAN",
		options: ["YES", "NO"],
		fieldname: "environmental_toxins",
		value: "",
		placeholder: ""
	},
	{
		question: "Do you consume *Alcohol*?",
		question_type: "BOOLEAN",
		options: ["YES", "NO"],
		fieldname: "alcohol_consumption",
		value: "",
		placeholder: ""
	},
	{
		question: "Do you consume *Tobacco*?",
		question_type: "BOOLEAN",
		options: ["YES", "NO"],
		fieldname: "tobacco_consumption",
		value: "",
		placeholder: ""
	},
	{
		question: "How often do you consume *junk food* such as *chips*, *cookies*, or *fast food*?",
		question_type: "BOOLEAN",
		options: ["RARELY NEVER", "ONCE A WEEK", "2-3 TIMES", "MORE THAN 3 TIMES"],
		fieldname: "daily_junk_food_consumption",
		value: "",
		placeholder: ""
	},
	{
		question: "Do you have *high blood pressure*?",
		question_type: "BOOLEAN",
		options: ["YES", "NO"],
		fieldname: "blood_pressure",
		value: "",
		placeholder: ""
	},
	{
		question: "Do you have *diabetes*?",
		question_type: "BOOLEAN",
		options: ["YES", "NO"],
		fieldname: "diabetes",
		value: "",
		placeholder: ""
	},
	{
		question: "Do you have *high cholesterol*?",
		question_type: "BOOLEAN",
		options: ["YES", "NO"],
		fieldname: "cholesterol",
		value: "",
		placeholder: ""
	},
	{
		question: "Do you have *thyroid issues*?",
		question_type: "BOOLEAN",
		options: ["YES", "NO"],
		fieldname: "thyroid",
		value: "",
		placeholder: ""
	},
	{
		question: "How often do you consume *processed foods* like *Frozen dinners*, *Packaged deli meats/snacks*?",
		question_type: "MULTIPLE_CHOICE_QUESTION",
		options: ["RARELY NEVER", "1-3 DAYS", "4-6 DAYS", "EVERYDAY"],
		fieldname: "processed_food_consumption",
		value: "",
		placeholder: ""
	},
	{
		question: "How much you spent time *infront of screen*?",
		question_type: "MULTIPLE_CHOICE_QUESTION",
		options: ["1-3 HOURS", "3-5 HOURS", "MORE THAN 5 HOURS"],
		fieldname: "screen_on_time",
		value: "",
		placeholder: ""
	},
	{
		question: "How would you rate your *stress level* on average?",
		question_type: "MULTIPLE_CHOICE_QUESTION",
		options: ["LOW", "NORMAL", "MEDIUM", "HIGH"],
		fieldname: "stress_level",
		value: "",
		placeholder: ""
	},
	{
		question: "How often do you consume *sugary snacks* or *desserts*?",
		question_type: "MULTIPLE_CHOICE_QUESTION",
		options: ["RARELY NEVER", "1-3 DAYS", "4-6 DAYS", "EVERYDAY"],
		fieldname: "sugar_consumption",
		value: "",
		placeholder: ""
	},
	{
		question: "How often do you eat *meals at irregular times* (e.g., skipping meals, eating very late)?",
		question_type: "MULTIPLE_CHOICE_QUESTION",
		options: ["RARELY NEVER", "1-3 DAYS", "4-6 DAYS", "EVERYDAY"],
		fieldname: "irregular_eating_time",
		value: "",
		placeholder: ""
	}
];

export const healthTestQuestionnaireFieldsInitalState: HealthTestQuestionnaireFields = {
	date_of_birth: "",
	weight: "",
	height: "",
	daily_water_drinking: "",
	sleep_time: "",
	regular_exercise: "",
	regular_health_checkup: "",
	meditation_practice: "",
	social_connections: "",
	environmental_toxins: "",
	alcohol_consumption: "",
	tobacco_consumption: "",
	daily_junk_food_consumption: "",
	blood_pressure: "",
	diabetes: "",
	cholesterol: "",
	thyroid: "",
	processed_food_consumption: "",
	screen_on_time: "",
	stress_level: "",
	sugar_consumption: "",
	irregular_eating_time: ""
};
